<template>
  <div class="personal-wallpaper-item">
    <img :src="data.preview_jpg" alt>
  </div>
</template>

<script>
export default {
  name: 'PersonalMobileWallpaperItem',
  props: {
    data: {
      type: Object,
      default() {
        return {}
      },
    },
  },
}
</script>

<style scoped lang="scss">
.personal-wallpaper-item {
  width: 1.65rem;
  height: .92rem;
  display: flex;
  justify-content: center;
    img {
        width: 100%;
        height: .92rem;
        border-radius: 8px;
  }
  .name {
    border-radius: 8px 8px 0 0;
    z-index: 1;
    position: absolute;
    left: 0;
    right: 0;
    top: 0px;
    height: 32px;
    padding-left: 10px;
    line-height: 32px;
    font-size: 14px;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0));
    color: #fff;
  }
}
</style>
